import { Component, OnInit, TemplateRef, Input, ViewChild } from '@angular/core';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap';
import { HelpdeskService } from './helpdesk.service';
import { HelpDesk } from './helpdesk';
//import { TooltipModule } from "ngx-tooltip";

@Component({
  selector: 'app-helpdesk',
  templateUrl: './helpdesk.component.html',
  styleUrls: ['./helpdesk.component.css'],
  providers: [HelpdeskService]
})
export class HelpdeskComponent implements OnInit {
  @Input() menuId: number;
  @Input() pageName: string;
  public msg: string; modalRef: BsModalRef; msgExists: boolean; 
  _helpDeskModel: HelpDesk = new HelpDesk();
  config: ModalOptions = {
    /*backdrop: 'static',
    keyboard: false,
    animated: true,*/
    class: 'modal-dialog-centered',
    ignoreBackdropClick: false
  }

  constructor(private modalService: BsModalService, private _helpDeskService: HelpdeskService) { }

  ngOnInit() {
    this.msg = '';
    this.msgExists = false;
    this.LoadHelpDeskInfo(this.menuId, this.pageName);
  }
  openModal(template: TemplateRef<any>) {    
    this.modalRef = this.modalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");
  }

 LoadHelpDeskInfo(menuid, pagename) {
    this._helpDeskModel.menuid = menuid;
    this._helpDeskModel.pagename = pagename;
    this._helpDeskModel.helpcontent = '';
    this._helpDeskModel.active = 0;
    this._helpDeskModel.helpdeskid = 0;
    this._helpDeskModel.createdby = 0;
    this._helpDeskModel.createdon = '';
    this._helpDeskModel.modifiedon = '';
    this._helpDeskModel.modifiedby = 0;
    this._helpDeskService.Get(this._helpDeskModel).subscribe(res => {
      if (res != undefined) {
        if (res.body.length != 0) {
          if ((res.body[0].helpcontent != '') || (res.body[0].helpcontent != undefined)) {
            this.msg = res.body[0].helpcontent; this.msgExists = true;
          }
        else
          this.msg = 'No information found to display';       
        }
        else
          this.msg = 'No information found to display';  
      }
      else  
        this.msg = 'No information found to display';     
    });
  
 }
 
}
